import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import apiService from "../../services/api";
import VagaResumoCard from "../Cadastrar-Alunos/VagaResumoCard";

const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 2fr);
  min-height: calc(100vh - 122px);
  font-family: "Public Sans", sans-serif;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  border-right: 1px solid #e0e0e0;
`;

const BottomArea = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
  margin: 24px 0 0;
  padding: 0 20px;
`;

const Right = styled.div`
  min-width: 0;
  background: #ffffff;
  border-top: 1px solid #e0e0e0;
  border-right: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  padding: 12px 24px 20px;
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 18px;
`;

const Tab = styled.button`
  border: 0;
  border-bottom: 3px solid ${({ $active }) => ($active ? "#6ab8a8" : "transparent")};
  background: transparent;
  color: ${({ $active }) => ($active ? "#3f8276" : "#666")};
  padding: 12px 18px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
`;

const Panel = styled.div`
  background: #fff;
`;

const PanelTitle = styled.h2`
  margin: 0 0 12px;
  color: #ff9f1f;
  font-size: 16px;
  font-weight: 700;
`;

const Field = styled.div`
  padding: 12px 14px;
  border: 1px solid #dfe3e8;
  border-bottom: 0;

  &:last-child {
    border-bottom: 1px solid #dfe3e8;
  }
`;

const Label = styled.div`
  margin-bottom: 4px;
  color: #555;
  font-size: 14px;
  font-weight: 700;
`;

const Value = styled.div`
  color: #555;
  font-size: 15px;
  line-height: 1.45;
`;

const ActivityList = styled.ul`
  margin: 4px 0 0;
  padding-left: 20px;
`;

const StudentsHeader = styled.div`
  margin-bottom: 16px;
  color: #555;
  font-size: 15px;
  font-weight: 700;
`;

const Student = styled.details`
  border: 1px solid #dfe3e8;
  background: #e8f5f3;

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    cursor: pointer;
    list-style: none;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  &[open] summary > span:last-child {
    transform: rotate(180deg);
  }
`;

const StudentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  padding-right: 4px;
`;

const StudentIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

const PersonIcon = styled.span`
  font-family: "Material Symbols Outlined", sans-serif;
  font-size: 22px;
  color: #6ab8a8;
  flex-shrink: 0;
`;

const StudentName = styled.div`
  color: #555555;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StudentCpf = styled.div`
  color: #777777;
  font-size: 13px;
`;

const ExpandIcon = styled.span`
  color: #555555;
  font-size: 18px;
  flex-shrink: 0;
  transition: transform 0.15s ease;
`;

const StudentDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 0 14px 14px 46px;
  color: #555555;
  font-size: 14px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Empty = styled.div`
  padding: 32px;
  color: #666;
  text-align: center;
`;

const BackButton = styled.button`
  background: #999;
  color: #fff;
  border: none;
  padding: 8px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:hover {
    background: #888;
  }
`;

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleDateString("pt-BR");
};

const formatCpf = (value = "") => {
  const cpf = String(value).replace(/\D/g, "");
  return cpf.length === 11
    ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    : value || "-";
};

const Detail = ({ label, children }) => (
  <div>
    <Label>{label}</Label>
    <Value>{children || "-"}</Value>
  </div>
);

const ConfirmadaDetalheContent = () => {
  const { solicitacaoId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("dados");
  const [solicitacao, setSolicitacao] = useState(null);
  const [dados, setDados] = useState(null);
  const [alunos, setAlunos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const result = await apiService.getSolicitacoesVaga("CONFIRMADA");
        const items = Array.isArray(result?.data) ? result.data : result;
        const selected = (Array.isArray(items) ? items : []).find(
          (item) => Number(item.id) === Number(solicitacaoId)
        );
        if (!selected) throw new Error("Vaga confirmada não encontrada.");

        setSolicitacao(selected);
        const [dadosResult, alunosResult] = await Promise.all([
          apiService.getDadosEstagio(selected.id),
          apiService.getAlunosEstagio(selected.id),
        ]);
        setDados(dadosResult || null);
        setAlunos(Array.isArray(alunosResult) ? alunosResult : []);
      } catch (err) {
        setError(err.message || "Não foi possível carregar a vaga confirmada.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [solicitacaoId]);

  if (loading) return <Empty>Carregando...</Empty>;
  if (error) return <Empty>{error}</Empty>;

  const total = solicitacao.quantidadeAlunosConcedidos ?? solicitacao.quantidadeAlunos ?? 0;
  const atividades = dados?.atividades || [];
  const handleVoltar = () => {
    const returnPath = ["/TermoCompromisso", "/TermoCompromissoPendentes"].includes(
      location.state?.returnPath
    )
      ? location.state.returnPath
      : "/Confirmadas";
    navigate(returnPath);
  };

  return (
    <>
      <Layout>
        <Left>
          <VagaResumoCard solicitacao={solicitacao} wide />
          <BottomArea>
            <BackButton type="button" onClick={handleVoltar}>
              Voltar
            </BackButton>
          </BottomArea>
        </Left>
        <Right>
          <Tabs role="tablist" aria-label="Detalhes da vaga confirmada">
            <Tab
              type="button"
              role="tab"
              aria-selected={activeTab === "dados"}
              $active={activeTab === "dados"}
              onClick={() => setActiveTab("dados")}
            >
              Dados do estágio
            </Tab>
            <Tab
              type="button"
              role="tab"
              aria-selected={activeTab === "alunos"}
              $active={activeTab === "alunos"}
              onClick={() => setActiveTab("alunos")}
            >
              Alunos cadastrados ({alunos.length})
            </Tab>
          </Tabs>

          {activeTab === "dados" && (
            <Panel role="tabpanel">
              <PanelTitle>Dados do estágio</PanelTitle>
              <Field><Detail label="Fase curricular">{dados?.instituicaoCurricular}</Detail></Field>
              <Field>
                <Label>Atividades a serem desenvolvidas</Label>
                <Value>
                  {atividades.length ? (
                    <ActivityList>
                      {atividades.map((atividade) => (
                        <li key={atividade.id || atividade.descricao}>{atividade.descricao}</li>
                      ))}
                    </ActivityList>
                  ) : "-"}
                </Value>
              </Field>
              <Field><Detail label="Nº da apólice de seguro">{dados?.apoliceNumero}</Detail></Field>
              <Field><Detail label="Nome da seguradora">{dados?.seguradoraNome}</Detail></Field>
              <Field>
                <Detail label="Vigência do seguro">
                  {`${formatDate(dados?.seguroVigenciaInicio)} a ${formatDate(dados?.seguroVigenciaFim)}`}
                </Detail>
              </Field>
              <Field>
                <Detail label="Dias da semana">
                  {(solicitacao.diasSemana || []).map((dia) => dia.diaSemana).join(", ") || "-"}
                </Detail>
              </Field>
            </Panel>
          )}

          {activeTab === "alunos" && (
            <Panel role="tabpanel">
              <PanelTitle>Alunos cadastrados</PanelTitle>
              <StudentsHeader>{alunos.length} de {total} alunos cadastrados</StudentsHeader>
              {alunos.length === 0 && <Empty>Nenhum aluno cadastrado.</Empty>}
              <StudentList>
                {alunos.map((aluno) => (
                  <Student key={aluno.id}>
                    <summary>
                      <StudentIdentity>
                        <PersonIcon aria-hidden="true">person</PersonIcon>
                        <div>
                          <StudentName>{aluno.nome}</StudentName>
                          <StudentCpf>{formatCpf(aluno.cpf)}</StudentCpf>
                        </div>
                      </StudentIdentity>
                      <ExpandIcon aria-hidden="true">▾</ExpandIcon>
                    </summary>
                    <StudentDetails>
                      <Detail label="Data de nascimento">{formatDate(aluno.dataNascimento)}</Detail>
                      <Detail label="Matrícula">{aluno.numeroMatricula}</Detail>
                      <Detail label="Horário">{aluno.horarioRealizacao}</Detail>
                      <Detail label="Dias da semana">
                        {(aluno.diasSemana || []).map((dia) => dia.diaSemana).join(", ") || "-"}
                      </Detail>
                    </StudentDetails>
                  </Student>
                ))}
              </StudentList>
            </Panel>
          )}
        </Right>
      </Layout>
    </>
  );
};

export default ConfirmadaDetalheContent;
